import { render, staticRenderFns } from "./handselCard.vue?vue&type=template&id=7ac146ab&scoped=true&"
import script from "./handselCard.vue?vue&type=script&lang=js&"
export * from "./handselCard.vue?vue&type=script&lang=js&"
import style0 from "./handselCard.vue?vue&type=style&index=0&id=7ac146ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac146ab",
  null
  
)

export default component.exports